var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CacheCategory } from "../../constants/lookups/lookup.constants";
export var LookupValueQuery = {
    lotteryDrawDates: "LotteryDrawDates",
    agentWinningClaimPayoutStatuses: "agentWinningClaimPayoutStatuses",
    departments: "departments",
    branches: "branches",
    roles: "roles",
    Users: "Users",
    templates: "Templates",
    lotteryWidgets: "LotteryWidgets",
    brandThemes: "BrandThemes",
    languages: "languages",
    sports: "sports",
    currencies: "currencies",
    brands: "brands",
    operators: "operators",
    sweepstakeCategories: "sweepstakeCategories"
};
export var LookupAdditionalData = {
    tag: "tag",
    scope: "scope",
    branchId: "branchId",
    visibleForScopes: "visibleForScopes",
    parentId: "parentId",
    isActive: "isActive",
    isForAccept: "isForAccept",
    proposalPluginId: "proposalPluginId",
    code: "code",
    isSelectable: "isSelectable",
    sexType: "sexType",
    maritalStatusType: "maritalStatusType",
    knownEmploymentType: 'knownEmploymentType',
    educationTypeLevel: "educationTypeLevel",
    departmentId: "departmentId",
    isTrust: "isTrust",
    curencyCode: "curencyCode",
    exchangeCode: "exchangeCode",
    bondTypeValue: "bondTypeValue",
    profitStrategyType: "profitStrategyType",
    isCancellableOnwards: "isCancellableOnwards",
    nextOrderState: "nextOrderState",
    isBaseCurrency: "isBaseCurrency",
    cultureString: "cultureString",
    symbol: "symbol",
    daysInYear: "daysInYear",
    orderInvolvmentId: "orderInvolvmentId",
    defaultForTestPassed: "defaultForTestPassed",
    description: "description",
    showOnFailedAppropiatnessTestOnly: "showOnFailedAppropiatnessTestOnly",
    settlementPeriodDays: "settlementPeriodDays"
};
var BaseCacheItem = /** @class */ (function () {
    function BaseCacheItem() {
    }
    BaseCacheItem.prototype.getCacheKey = function () {
        return (this.getCategory() + "_" + this.getCacheKeyOverride()).toLowerCase();
    };
    return BaseCacheItem;
}());
export { BaseCacheItem };
export var OrderByEnum;
(function (OrderByEnum) {
    OrderByEnum[OrderByEnum["NONE"] = 0] = "NONE";
    OrderByEnum[OrderByEnum["NameASC"] = 1] = "NameASC";
    OrderByEnum[OrderByEnum["NameDSC"] = 2] = "NameDSC";
    OrderByEnum[OrderByEnum["IDASC"] = 3] = "IDASC";
    OrderByEnum[OrderByEnum["IDDSC"] = 4] = "IDDSC";
})(OrderByEnum || (OrderByEnum = {}));
var LookupValueRequest = /** @class */ (function (_super) {
    __extends(LookupValueRequest, _super);
    function LookupValueRequest(lookupValueQuery, parameters) {
        if (lookupValueQuery === void 0) { lookupValueQuery = null; }
        if (parameters === void 0) { parameters = ""; }
        var _this = _super.call(this) || this;
        _this.lookupValueQuery = lookupValueQuery;
        _this.parameters = parameters;
        _this.filterByIsActive = true;
        _this.overrideMetaDataFiltering = false;
        _this.orderBy = OrderByEnum.NONE;
        _this.clientLastModifiedDate = new Date();
        return _this;
    }
    LookupValueRequest.prototype.setOverrideMetaDataFiltering = function (orderbyEnum) {
        this.overrideMetaDataFiltering = true;
        this.orderBy = orderbyEnum;
    };
    LookupValueRequest.prototype.getCacheKeyOverride = function () {
        var cacheKey = "".concat(this.lookupValueQuery, "_").concat((this.filterByIsActive != null ? this.filterByIsActive : true));
        if (this.parameters) {
            cacheKey += "_" + this.parameters;
        }
        return cacheKey;
    };
    LookupValueRequest.prototype.getCategory = function () {
        return CacheCategory.lookups;
    };
    return LookupValueRequest;
}(BaseCacheItem));
export { LookupValueRequest };
var Lookup = /** @class */ (function () {
    function Lookup() {
    }
    return Lookup;
}());
export { Lookup };
var LookupValue = /** @class */ (function () {
    function LookupValue() {
    }
    return LookupValue;
}());
export { LookupValue };
var SelectableLookupValue = /** @class */ (function (_super) {
    __extends(SelectableLookupValue, _super);
    function SelectableLookupValue() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selected = false;
        return _this;
    }
    return SelectableLookupValue;
}(LookupValue));
export { SelectableLookupValue };
var ConfirmationDialogModel = /** @class */ (function () {
    function ConfirmationDialogModel() {
        this.headerTitle = 'default-confirm-header-title';
        this.headerTitleTranslateProps = {};
        this.headerMessageTranslateProps = {};
        this.btnOkayText = 'yes-text';
        this.btnNoText = 'no-text';
    }
    return ConfirmationDialogModel;
}());
export { ConfirmationDialogModel };
var MessageDialogModel = /** @class */ (function () {
    function MessageDialogModel() {
        this.messageTranslateProps = {};
    }
    return MessageDialogModel;
}());
export { MessageDialogModel };
var LookupValueResponse = /** @class */ (function () {
    function LookupValueResponse() {
    }
    return LookupValueResponse;
}());
export { LookupValueResponse };
var TableMetaDataResponse = /** @class */ (function () {
    function TableMetaDataResponse() {
    }
    return TableMetaDataResponse;
}());
export { TableMetaDataResponse };
var TableColumnMetaDataResponse = /** @class */ (function () {
    function TableColumnMetaDataResponse() {
    }
    return TableColumnMetaDataResponse;
}());
export { TableColumnMetaDataResponse };
var PersistLookupValuesRequest = /** @class */ (function () {
    function PersistLookupValuesRequest() {
    }
    return PersistLookupValuesRequest;
}());
export { PersistLookupValuesRequest };
var PersistLookupsValuesRequest = /** @class */ (function () {
    function PersistLookupsValuesRequest() {
    }
    return PersistLookupsValuesRequest;
}());
export { PersistLookupsValuesRequest };
